import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./CareersCRUD.scss";

import axios from "axios";

import JobView from "../Careers/JobView";

import { useNavigate } from "react-router-dom";

import { updateSelectedJob } from "../../state/action-creators";

import {
  Spinner,
  InputGroup,
  InputRightElement,
  Button,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  FormHelperText,
} from "@chakra-ui/react";

import { AddIcon, WarningIcon, ArrowForwardIcon } from "@chakra-ui/icons";

const PASSWORD = process.env.REACT_APP_CAREER_CRUD_OPERATION_TOKEN;

const EMPTY_STATE_TEXT = "No jobs available!";
const PASSWORD_PLACEHOLDER_TEXT = "Enter password";
const INVALID_PASSWORD = "Entered invalid password!";
const GET_LABEL_FROM_ADMIN =
  "If you don't have password, please reach out to workoza admin.";

const CareersCRUD = (props) => {
  const { updateSelectedJob, userFromCreateJob, userFromViewJob } = props;

  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [isValidPassword, setIsValidPassword] = useState(true);
  const [isCorrectPassword, setIsCorrectPassword] = useState(false);
  const [allJobs, setAllJobs] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const fetchAllJobs = async () => {
      try {
        setIsLoading(true);
        const res = await axios.get(
          `https://workoza-server-vercel.vercel.app/api/job`
        );
        setAllJobs(res?.data);
      } catch (e) {
        console.log(e);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAllJobs();
  }, []);

  const fetchAllJobs = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `https://workoza-server-vercel.vercel.app/api/job`
      );
      setAllJobs(res?.data);
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  const renderCRUDKeyEnter = () => {
    const handleShowClick = () => setShow(!show);

    const handlePasswordChange = (e) => {
      setPassword(e?.target?.value);
    };

    const handleSubmitPassword = () => {
      setIsValidPassword(password === PASSWORD);
      setIsCorrectPassword(password === PASSWORD);
    };

    return (
      <div className="crudKeyWrapper">
        <div className="crudKeyContainer">
          <FormControl isRequired isInvalid={!isValidPassword}>
            <FormLabel>Enter password to perform changes</FormLabel>
            <InputGroup size="md">
              <Input
                type={show ? "text" : "password"}
                placeholder={PASSWORD_PLACEHOLDER_TEXT}
                value={password}
                onChange={handlePasswordChange}
              />
              <InputRightElement width="4.5rem">
                <Button h="1.75rem" size="sm" onClick={handleShowClick}>
                  {show ? "Hide" : "Show"}
                </Button>
              </InputRightElement>
            </InputGroup>
            <FormErrorMessage>{INVALID_PASSWORD}</FormErrorMessage>
            <FormHelperText>{GET_LABEL_FROM_ADMIN}</FormHelperText>
          </FormControl>
          <Button
            rightIcon={<ArrowForwardIcon />}
            size="md"
            variant="solid"
            color="#ffffff"
            background="#d33853"
            _hover={{ background: "#af273e", color: "#f9f9f9" }}
            onClick={handleSubmitPassword}
          >
            Submit
          </Button>
        </div>
      </div>
    );
  };

  const renderCRUDOperation = () => {
    const isJobsAvailable = allJobs.length;

    const renderCreateNewJob = () => {
      const handleCreateNewJob = () => {
        updateSelectedJob(null);
        navigate(
          `/careers/${process.env.REACT_APP_CAREER_CRUD_ROUTE}/create-job`
        );
      };

      return (
        <div className="crudFeedCreateJobContainer">
          <Button
            rightIcon={<AddIcon />}
            size="lg"
            variant="solid"
            color="#ffffff"
            background="#d33853"
            _hover={{ background: "#af273e", color: "#f9f9f9" }}
            onClick={handleCreateNewJob}
          >
            Create new job
          </Button>
        </div>
      );
    };

    const renderAllJobsFeed = () => {
      const renderAllJobs = () => {
        return allJobs?.map((jobDetails) => {
          return (
            <JobView
              jobDetails={jobDetails}
              fetchAllJobs={fetchAllJobs}
              isCrudButtonVisible={true}
            />
          );
        });
      };

      return <div className="allJobsWrapper">{renderAllJobs()}</div>;
    };

    return (
      <div className="crudFeedWrapper">
        {renderCreateNewJob()}
        {isLoading ? (
          <div className="crudLoadingContainer">
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="#717171"
              color="#d33853"
              size="lg"
            />
          </div>
        ) : isJobsAvailable > 0 ? (
          renderAllJobsFeed()
        ) : (
          <div className="crudEmptyStateContainer">
            <div className="crudEmptyStateText">
              <WarningIcon />
              {EMPTY_STATE_TEXT}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="crudContainer">
      <div className="crudWrapper">
        {isCorrectPassword || userFromCreateJob || userFromViewJob
          ? renderCRUDOperation()
          : renderCRUDKeyEnter()}
      </div>
    </div>
  );
};

const mapActionCreators = {
  updateSelectedJob,
};

const mapStateToProps = (state) => {
  const userFromCreateJob =
    state?.navbarStateChangeReducer?.isUserComingFromCreateJob;
  const userFromViewJob =
    state?.navbarStateChangeReducer?.isUserComingFromViewJob;

  return {
    userFromCreateJob,
    userFromViewJob,
  };
};

export default connect(mapStateToProps, mapActionCreators)(CareersCRUD);
